export default class CustomError extends Error {
	data;

	constructor(type, data) {
		super(type);
		this.data = data;
	}
}